const localStorageKeyPrefix = 'barde.';

const getKey = (key: string): string => localStorageKeyPrefix + key;

export const localStorageGet = (key: string): string | null => localStorage.getItem(getKey(key));

export const localStorageSet = (key: string, value: string): void => localStorage.setItem(getKey(key), value);

export const localStorageRemove = (key: string): void => localStorage.removeItem(getKey(key));
